import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Unit } from '@/shared/types/unit';

interface UnitsState {
  selectedUnit: Unit | null;
  createDialogOpen: boolean;
  editDialogOpen: boolean;
  editingUnit: Unit | null;
}

const initialState: UnitsState = {
  selectedUnit: null,
  createDialogOpen: false,
  editDialogOpen: false,
  editingUnit: null,
};

const unitsSlice = createSlice({
  name: 'units',
  initialState,
  reducers: {
    setSelectedUnit: (state, action: PayloadAction<Unit | null>) => {
      state.selectedUnit = action.payload;
    },
    openCreateDialog: (state) => {
      state.createDialogOpen = true;
      state.editingUnit = null;
    },
    closeCreateDialog: (state) => {
      state.createDialogOpen = false;
    },
    openEditDialog: (state, action: PayloadAction<Unit>) => {
      state.editDialogOpen = true;
      state.editingUnit = action.payload;
    },
    closeEditDialog: (state) => {
      state.editDialogOpen = false;
      state.editingUnit = null;
    },
  },
});

export const {
  setSelectedUnit,
  openCreateDialog,
  closeCreateDialog,
  openEditDialog,
  closeEditDialog,
} = unitsSlice.actions;

export default unitsSlice.reducer;
